function formulaExtractStrings(mainString, startString, endString) {
  // Create a regular expression pattern with startString and endString as delimiters
  const pattern = new RegExp(`${startString}(.*?)${endString}`, "g");

  // Use match() to find all matches in the mainString
  const matches = mainString.match(pattern);

  // Check if matches were found
  if (matches) {
    // Extract the captured groups from matches
    const result = matches.map((match) =>
      match.replace(startString, "").replace(endString, "")
    );
    return result;
  } else {
    // If no matches were found, return an empty array
    return [];
  }
}

export default formulaExtractStrings;
